import React from 'react';
import { List, Popup } from 'semantic-ui-react';

import './HoverList.scss';

const HoverList = ({ list }) => {
    return (
        <Popup
            className='HoverListComponent'
            basic
            on='hover'
            hoverable={true}
            position='bottom left'
            trigger={<div className='HoverListComponent__Trigger'>{list.map((item, index) => <span key={index}>{item}{`${index < list.length - 1 ? ',' : ''}`} </span>)}</div>}
            content={
                <div className='HoverListComponent__Container'>
                    <List style={{ color: 'black' }}>
                        {list.map((item, index) => (
                            <List.Item key={index}>{item}</List.Item>
                        ))}
                    </List>
                </div>
            }
        />
    );
}

export default HoverList;
